import { Breadcrumbs, DropDownMenu, FlashMessage, GlobalLoader, Modal, ModalAlert, Tabs, TextEditor } from '@reactiveonline/reactive_admin_shared-packages'
import React, { useEffect, useRef, useState } from 'react'
import GlobalImports from '../shared/GlobalImports'
import AccountNotices from './AccountNotices'
import AccountingTab from './AccountingTab'
import GeneralTab from './GeneralTab'
import InvoicingSoftwareTab from './InvoicingSoftwareTab'
import NotesTab from './NotesTab'
import DataTab from './DataTab'
import ApiIntegrationsTab from './ApiIntegrationsTab'
import TechnicalTab from './TechnicalTab'
import moment from 'moment-timezone'
import { SingleDatePicker } from 'react-dates'
import Toggle from "react-toggle"

export default function Show({
  appProps, acceptSignedContractPath, account, accountNotesPath, accountsPath,
  breadcrumbs, cancelOnboardingPath, canDeleteOrUpdateOldNotes, canGainAccess,
  canRequestAccess, canUnlockBillingProfile, canViewDatabaseUid,
  canManageInvoicingOnboarding, completeAuthorizationPath,
  confirmTenantEmailPath, createApiIntegrationPath, deleteApiIntegrationPath,
  downloadFilePath, duplicateAccounts, entityInvoiceSearchPath,
  erroneousInvoicesPath, errorLogsPath, offlineErrorLogsPath,
  failedPaymentsPath, gainAccessPath, getAccountNoticesAndGeneralDataPath,
  getApiIntegrationsDataPath, generateContractPath, getAccountingDataPath,
  getInvoicingSoftwareDataPath, getUsageDataPath,
  getTenantRequestAccessInfoPath, icon, invoicesPath, latestTenantAccessRequest,
  notifyCustomerForApiKeysPath, invoicingStatusUpdatePath,
  rejectAuthorizationPath, rejectContractPath, rejectInfoPath,
  rejectStatementPath, requestAccessPath, saveApiIntegrationKeysPath,
  sendConfirmationEmailPath, sendCustomEmailPath, sendImportOnboardingEmailPath,
  sendInvoicingSoftwareEmailPath, sendResetPasswordEmailPath,
  skipInvoicingOnboardingPath, skipTenantOnboardingPath, transactionsPath,
  unlockBillingProfilePath, updateSettingsPath, uploadContractPath,
  switchToMonthlyPlanPath, restrictedAccess, canSwitchToMonthlyPlan,
  isSuperadmin, submitRevisedOfflineTransactionBodyPath, destroyErrorLogPath,
  currentAdminEmail, checkInvoicingStatusPath, canCheckInvoicingStatus,
  canAdminMoveAccounts, moveAccountPath, canSkipInvoicingOnboarding
}) {
  const [currentTab, setCurrentTab] = useState('general')
  const [accountNoticesData, setAccountNoticesData] = useState({
    vatNumber: null,
    duplicateAccounts: []
  })
  const [generalData, setGeneralData] = useState(null)
  const [accountingData, setAccountingData] = useState(null)
  const [usageData, setUsageData] = useState(null)
  const [invoicingSoftwareData, setInvoicingSoftwareData] = useState(null)
  const [apiIntegrationsData, setApiIntegrationsData] = useState(null)
  const [lastTenantAccessRequest, setLastTenantAccessRequest] = useState(latestTenantAccessRequest)
  const [notes, setNotes] = useState(account.notes)
  const [emailText, setEmailText] = useState('')
  const [showCustomEmailModal, setShowCustomEmailModal] = useState(false)
  const [showSendCustomEmailAlert, setShowSendCustomEmailAlert] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showChangePlanModal, setShowChangePlanModal] = useState(false)
  const [selectedDate, setSelectedDate] = useState(moment(new Date()).add(1, 'day'))
  const [focusedInput, setFocusedInput] = useState(null)
  const [optForReminder, setOptForReminder] = useState(false)
  const [paymentMethods, setPaymentMethods] = useState([])
  const [validToBeMoved, setValidToBeMoved] = useState(false)

  const flashMessageRef = useRef(null)

  const tabs = [
    { key: 'general',            title: Support.translations.general    },
    { key: 'accounting',         title: Support.translations.accounting }
  ]
  if (restrictedAccess) {
    tabs.push({ key: 'notes',    title: Support.translations.notes      })
  }
  if (account.flavour.toLowerCase() != 'website') {
    if (restrictedAccess) {
      tabs.push(
        { key: 'data',               title: Support.translations.data               },
        { key: 'invoicing_software', title: Support.translations.invoicing_software },
        { key: 'api_integrations',   title: Support.translations.api_integrations   }
      )
    }
  }

  if (isSuperadmin) {
    tabs.push({
      key: 'technical',
      title: Support.translations.technical
    })
  }

  const dropdownActions = [
    {
      icon: 'fa-circle-check',
      action: confirmTenantEmail,
      text: Support.translations.account.confirm_tenant_email,
      permissions: !!generalData && !generalData?.confirmedEmail
    },
    {
      icon: 'fa-flag',
      action: skipTenantOnboarding,
      text: Support.translations.account.skip_tenant_onboarding,
      permissions: !!generalData && !generalData?.hasReceivedTour
    },
    {
      icon: 'fa-envelope',
      action: sendConfirmationEmail,
      text: Support.translations.account.resend_confirmation_email,
      permissions: !!generalData && !generalData?.confirmedEmail && !generalData?.bulkImported
    },
    {
      icon: 'fa-envelope',
      action: sendImportOnboardingEmail,
      text: Support.translations.account.resend_import_onboarding_email,
      permissions: !!generalData && !generalData?.confirmedEmail && generalData?.bulkImported
    },
    {
      icon: 'fa-key',
      action: sendResetPasswordEmail,
      text: Support.translations.account.send_reset_password_email,
      permissions: true
    },
    {
      icon: 'fa-square-envelope',
      action: _e => setShowCustomEmailModal(true),
      text: Support.translations.account.send_custom_email,
      permissions: true
    },
    {
      icon: 'fa-file-invoice',
      action: _ => handleCheckStatus(),
      text: Support.translations.account.check_invoicing_status,
      permissions: canCheckInvoicingStatus
    }
  ]

  useEffect(() => {
    setLoading(true)

    Rails.ajax({
      type: 'GET',
      url: getAccountNoticesAndGeneralDataPath,
      dataType: 'json',
      success: res => {
        setAccountNoticesData(res.noticesData)
        setGeneralData(res.generalData)
        setPaymentMethods(res.paymentMethods)
        setLoading(false)
        setValidToBeMoved(res.generalData?.validToBeMoved)
      }
    })
  }, [])

  function handleCheckStatus() {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: checkInvoicingStatusPath,
      dataType: 'json',
      success: res => {
        setLoading(false)

        if (res.invoicing_up_and_api_key_enabled === true) {
          flashMessageRef.current.show(Support.translations.account.api_key_enabled_success)
        } else {
          flashMessageRef.current.show(Support.translations.account.api_key_enabled_failure, 'error')
        }
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  function sendResetPasswordEmail() {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: sendResetPasswordEmailPath,
      dataType: 'json',
      success: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  function skipTenantOnboarding(_e) {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: skipTenantOnboardingPath,
      dataType: 'json',
      success: res => {
        flashMessageRef.current.show(res.message)

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  function confirmTenantEmail(_e) {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: confirmTenantEmailPath,
      dataType: 'json',
      success: res => {
        flashMessageRef.current.show(res.message)

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  function sendConfirmationEmail(_e) {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: sendConfirmationEmailPath,
      dataType: 'json',
      success: res => {
        flashMessageRef.current.show(res.message)

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  function sendImportOnboardingEmail(_e) {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: sendImportOnboardingEmailPath,
      dataType: 'json',
      success: res => {
        flashMessageRef.current.show(res.message)

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  const handleCloseCustomEmailModal = () => {
    setShowCustomEmailModal(false)
    setEmailText('')
    setFocusedInput(null)
    setSelectedDate(moment(new Date()).add(1, 'day'))
    setOptForReminder(false)
  }

  const handleCloseAlert = () => {
    setShowSendCustomEmailAlert(false)
  }

  const handleCloseChangePlanModal = () => {
    setShowChangePlanModal(false)
  }

  const handleSendCustomEmail = _e => {
    setShowSendCustomEmailAlert(false)

    const fd = new FormData()
    fd.append('email_content', emailText)

    if (optForReminder) {
      fd.append('reminder_date', selectedDate)
    }

    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: sendCustomEmailPath,
      dataType: 'json',
      data: fd,
      success: res => {
        setShowCustomEmailModal(false)
        setEmailText('')
        setFocusedInput(null)
        setSelectedDate(moment(new Date()).add(1, 'day'))
        setOptForReminder(false)
        flashMessageRef.current.show(res.message)
        setTimeout( ()=> {
          window.location.reload()
        }, 3000)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  const handleSwitchToMonthlyPlan = _e => {
    setShowChangePlanModal(false)
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: switchToMonthlyPlanPath,
      dataType: 'json',
      success: res => {
        flashMessageRef.current.show(res.message)
        setTimeout( ()=> {
          window.location.reload()
        }, 3000)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  return (
    <>
      <AccountNotices
        accountsPath={ accountsPath }
        accountNoticesData={ accountNoticesData }
        canUnlockBillingProfile={ canUnlockBillingProfile }
        duplicateAccounts={ duplicateAccounts }
        flashMessageRef={ flashMessageRef }
        setAccountNoticesData={ setAccountNoticesData }
        setLoading={ setLoading }
        unlockBillingProfilePath={ unlockBillingProfilePath }
        migrationStatus={ account.migrationStatus }
      />

      <div className='page-wrapper-header'>
        <div>
          <div className='page-header'>
            <i className={ `fa-light ${ icon }` }/>
            <h1 className='page-header-title'>
              { account.name }
            </h1>
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <div className='card'>
        <div className='card-content'>
          <div className='card-body'>
            <div className='flex-box items-center content-space-between'>
              <Tabs
                tabs={ tabs }
                currentTab={ currentTab }
                setCurrentTab={ tab => setCurrentTab(tab) }
                extraClasses={ 'secondary m-t-0' }
              />
              { restrictedAccess && !account.migrationStatus &&
                <DropDownMenu
                  items={ dropdownActions }
                  title={ ReactiveCore.translations.dropMenuAction }
                />
              }
            </div>
          </div>
        </div>
      </div>

      { currentTab === 'general' &&
        <GeneralTab
          account={ account }
          canGainAccess={ canGainAccess }
          canRequestAccess={ canRequestAccess }
          canViewDatabaseUid={ canViewDatabaseUid }
          canSwitchToMonthlyPlan={ canSwitchToMonthlyPlan }
          flashMessageRef={ flashMessageRef }
          gainAccessPath={ gainAccessPath }
          getTenantRequestAccessInfoPath={ getTenantRequestAccessInfoPath }
          generalData={ generalData }
          lastTenantAccessRequest={ lastTenantAccessRequest }
          requestAccessPath={ requestAccessPath }
          setLastTenantAccessRequest={ setLastTenantAccessRequest }
          setLoading={ setLoading }
          setShowChangePlanModal={ setShowChangePlanModal }
          validToBeMoved={ validToBeMoved && canAdminMoveAccounts }
          moveAccountPath={ moveAccountPath }
          loading={ loading }
        />
      }

      { currentTab === 'accounting' &&
        <AccountingTab
          accountingData={ accountingData }
          getAccountingDataPath={ getAccountingDataPath }
          invoicesPath={ invoicesPath }
          setAccountingData={ setAccountingData }
          setLoading={ setLoading }
          transactionsPath={ transactionsPath }
        />
      }

      { currentTab === 'notes' &&
        <NotesTab
          canDeleteOrUpdateOldNotes={ canDeleteOrUpdateOldNotes }
          notes={ notes }
          setNotes={ setNotes }
          notesPath={ accountNotesPath }
          currentAdminEmail={ currentAdminEmail }
        />
      }

      { currentTab === 'data' &&
        <DataTab
          entityInvoiceSearchPath={ entityInvoiceSearchPath }
          erroneousInvoicesPath={ erroneousInvoicesPath }
          errorLogsPath={ errorLogsPath }
          failedPaymentsPath={ failedPaymentsPath }
          getUsageDataPath={ getUsageDataPath }
          setLoading={ setLoading }
          totalInvoices={ generalData?.totalInvoices }
          latestIssuedInvoice={ generalData?.latestIssuedInvoice }
          usageData={ usageData }
          setUsageData={ setUsageData }
          paymentMethods={ paymentMethods }
        />
      }

      { currentTab === 'invoicing_software' &&
        <InvoicingSoftwareTab
          canManageInvoicingOnboarding={ canManageInvoicingOnboarding }
          canSkipInvoicingOnboarding={ canSkipInvoicingOnboarding }
          acceptSignedContractPath={ acceptSignedContractPath }
          cancelOnboardingPath={ cancelOnboardingPath }
          completeAuthorizationPath={ completeAuthorizationPath }
          downloadFilePath={ downloadFilePath }
          flashMessageRef={ flashMessageRef }
          generateContractPath={ generateContractPath }
          getInvoicingSoftwareDataPath={ getInvoicingSoftwareDataPath }
          invoicingSoftwareData={ invoicingSoftwareData }
          notifyCustomerForApiKeysPath={ notifyCustomerForApiKeysPath }
          rejectAuthorizationPath={ rejectAuthorizationPath }
          rejectContractPath={ rejectContractPath }
          rejectInfoPath={ rejectInfoPath }
          rejectStatementPath={ rejectStatementPath }
          saveApiIntegrationKeysPath={ saveApiIntegrationKeysPath }
          sendInvoicingSoftwareEmailPath={ sendInvoicingSoftwareEmailPath }
          setInvoicingSoftwareData={ setInvoicingSoftwareData }
          loading={ loading }
          setLoading={ setLoading }
          skipInvoicingOnboardingPath={ skipInvoicingOnboardingPath }
          updateSettingsPath={ updateSettingsPath }
          uploadContractPath={ uploadContractPath }
          invoicingStatusUpdatePath={ invoicingStatusUpdatePath }
        />
      }

      { currentTab === 'api_integrations' &&
        <ApiIntegrationsTab
          apiIntegrationsData={ apiIntegrationsData }
          createApiIntegrationPath={ createApiIntegrationPath }
          deleteApiIntegrationPath={ deleteApiIntegrationPath }
          flashMessageRef={ flashMessageRef }
          getApiIntegrationsDataPath={ getApiIntegrationsDataPath }
          loading={ loading }
          setApiIntegrationsData={ setApiIntegrationsData }
          setLoading={ setLoading }
        />
      }

      { currentTab === 'technical' &&
        <TechnicalTab
          destroyErrorLogPath={ destroyErrorLogPath }
          offlineErrorLogsPath={ offlineErrorLogsPath }
          setLoading={ setLoading }
          submitRevisedOfflineTransactionBodyPath={ submitRevisedOfflineTransactionBodyPath }
        />
      }

      { showCustomEmailModal &&
        <Modal
          visible
          closeModal={ handleCloseCustomEmailModal }
          mode="xlarge"
          action={ () => setShowSendCustomEmailAlert(true) }
          actionText={ Support.translations.send }
          disableAction={ !emailText }
        >
          <>
            <div
              className='flex-box flex-column content-center'
              style={{ width: '100%', height: '100%' }}
            >
              <div className='title bold'>
                { Support.translations.account.send_custom_email }
              </div>

              <div className='input-field' style={{ height: '100%' }}>
                <div className='flex-box items-center'>
                  <label>
                    { Support.translations.account.custom_email_content }
                  </label>
                </div>

                <TextEditor
                  content={ emailText }
                  setContent={ setEmailText }
                />
              </div>
            </div>
          </>

          <div className='flex-box content_start'>
            <div className='p-r-10'>
              <label>{ Support.translations.account.receive_reminder }</label>
            </div>

            <Toggle
              icons={{ unchecked: null }}
              className='reactToggle-element small'
              checked={ optForReminder }
              onChange={ e => setOptForReminder(e.target.checked) }
            />
          </div>

          { optForReminder &&
            <>
              <div className='flex-box content_start m-t-20'>
                <SingleDatePicker
                  displayFormat={() => "DD MMM YYYY"}
                  date={ selectedDate }
                  onDateChange={ date => { setSelectedDate(date); setFocusedInput(null) } }
                  focused={ focusedInput }
                  onFocusChange={ setFocusedInput }
                  id="date_picker_id"
                  hideKeyboardShortcutsPanel
                  isOutsideRange={ date => date < moment(new Date()).add(1, 'day') }
                />
              </div>
            </>
          }

          { loading && <GlobalLoader fullPage /> }
        </Modal>
      }

      { showSendCustomEmailAlert &&
        <ModalAlert
          alert={ `${ Support.translations.account.send_custom_email_alert } ${ account.email }` }
          onSelect={ handleSendCustomEmail }
          onClose={ handleCloseAlert }
        />
      }

      { showChangePlanModal &&
        <ModalAlert
          alert={ `${Support.translations.account.switch_to_monthly_plan_alert} ${account.domain}, ${account.email}` }
          onSelect={ handleSwitchToMonthlyPlan }
          onClose={ ()=> setShowChangePlanModal(false) }
        />
      }

      { loading && <GlobalLoader fullPage /> }

      <FlashMessage ref={ flashMessageRef } />
      <GlobalImports appProps={ appProps } />
    </>
  )
}
